var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.packet).length > 0)?_c('div',[_c('TRItemsListV1',{attrs:{"viewdata":{packet: _vm.packet, params: _vm.request_parameters}}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ce39e7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Receiving/ReceivingCustomerPickup.vue
// module id = null
// module chunks = 